// src/hooks/usePasteUpload.js
import { useEffect } from 'react';

/**
 * Listens for paste events and calls onFile(file) for any pasted images.
 */
export default function usePasteUpload(onFile) {
  useEffect(() => {
    const handler = e => {
      for (const item of e.clipboardData?.items || []) {
        if (item.type.startsWith('image/')) {
          onFile(item.getAsFile());
        }
      }
    };
    window.addEventListener('paste', handler);
    return () => window.removeEventListener('paste', handler);
  }, [onFile]);
}
